class SubscriptionBuilder {
  constructor(container) {
    this.container = container;
    this.sectionId = container.dataset.sectionId;
    
    // Estado
    this.state = {
      familia: null,
      plan: null,
    };

    // Configuración
    this.config = this.loadConfig();
    if (!this.config) return;

    // Elementos DOM
    this.dom = {
      stepFamilia: container.querySelector('#step-familia'),
      stepPlan: container.querySelector('#step-plan'),
      familiaButtons: container.querySelectorAll('[data-familia]'),
      planButtons: container.querySelectorAll('[data-plan]'),
      notes: container.querySelector('#sub-builder-notes'),
      
      summaryFamilia: container.querySelector('#summary-familia'),
      summaryPlan: container.querySelector('#summary-plan'),
      summaryAhorro: container.querySelector('#summary-ahorro'),
      summaryEnvio: container.querySelector('#summary-envio'),
      ctaButton: container.querySelector('#sub-builder-cta'),
    };

    this.init();
  }

  loadConfig() {
    const configScript = document.getElementById(`sub-builder-config-${this.sectionId}`);
    if (!configScript) {
      console.error('Subscription Builder: No se encontró el JSON de configuración.');
      return null;
    }
    try {
      // Intenta parsear, si está vacío, devuelve null
      const configText = configScript.textContent.trim();
      if (!configText) {
         console.warn('Subscription Builder: El JSON de configuración está vacío. Pégalo en el editor de temas.');
         return null;
      }
      return JSON.parse(configText);
    } catch (e) {
      console.error('Subscription Builder: Error al parsear el JSON de configuración.', e);
      return null;
    }
  }

  init() {
    // CORRECCIÓN: Escuchar click directamente en cada botón para respuesta inmediata
    
    // 1. Botones de Familia
    this.dom.familiaButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault(); // Evita saltos o comportamientos extraños
        this.handleFamiliaSelect(e);
      });
    });

    // 2. Botones de Plan (Aquí estaba el fallo del doble click)
    this.dom.planButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.handlePlanSelect(e);
      });
    });

    // 3. Botón de comprar
    this.dom.ctaButton.addEventListener('click', this.addToCart.bind(this));
  }

  handleFamiliaSelect(e) {
    // Usamos closest para asegurar que capturamos el botón aunque clicken en el texto
    const button = e.target.closest('[data-familia]');
    if (!button) return;

    this.state.familia = button.dataset.familia;

    // Actualizar UI botones
    this.dom.familiaButtons.forEach(btn => btn.setAttribute('aria-checked', 'false'));
    button.setAttribute('aria-checked', 'true');

    // Mostrar siguiente paso
    this.dom.stepPlan.style.display = 'block';
    this.dom.notes.style.display = 'block';
    
    // Si ya había un plan, re-evaluar, si no, solo actualizar familia
    this.updateSummary();
  }

  handlePlanSelect(e) {
    const button = e.target.closest('[data-plan]');
    if (!button) return;

    this.state.plan = button.dataset.plan;

    // Actualizar UI botones
    this.dom.planButtons.forEach(btn => btn.setAttribute('aria-checked', 'false'));
    button.setAttribute('aria-checked', 'true');
    
    this.updateSummary();
  }

  updateSummary() {
    if (!this.config) {
        this.dom.ctaButton.textContent = 'Error: Falta Configuración';
        return;
    }
    const { familia, plan } = this.state;
    
    if (!familia) {
      this.dom.ctaButton.disabled = true;
      this.dom.ctaButton.textContent = 'Elige un café para empezar';
      return;
    }

    const familiaData = this.config.familias[familia];
    this.dom.summaryFamilia.textContent = familiaData.label;

    if (!plan) {
      this.dom.summaryPlan.textContent = '--';
      this.dom.summaryAhorro.textContent = '--';
      this.dom.summaryEnvio.textContent = '--';
      this.dom.ctaButton.disabled = true;
      this.dom.ctaButton.textContent = 'Elige una cantidad';
      return;
    }

    const planData = familiaData.planes[plan];
    // Recuperamos el texto del botón seleccionado para mostrarlo en el resumen
    const planLabelElement = this.dom.stepPlan.querySelector(`[data-plan="${plan}"] strong`);
    const planLabel = planLabelElement ? planLabelElement.textContent : plan;

    this.dom.summaryPlan.textContent = planLabel;
    this.dom.summaryAhorro.textContent = `${planData.descuento}%`;
    this.dom.summaryEnvio.textContent = planData.envio_incluido ? 'Incluido' : 'No incluido';

    this.dom.ctaButton.disabled = false;
    this.dom.ctaButton.textContent = 'Comprar ahora';
  }

  async addToCart() {
    if (!this.config) {
        alert("Error de configuración. Contacta con soporte.");
        return;
    }
    const { familia, plan } = this.state;
    if (!familia || !plan) return;

    this.dom.ctaButton.disabled = true;
    this.dom.ctaButton.textContent = 'Añadiendo...';

    try {
      const familiaData = this.config.familias[familia];
      const planData = familiaData.planes[plan];

      const variantId = familiaData.variants[planData.variant_size];
      const quantity = planData.qty;
      const sellingPlanId = planData.selling_plan_id;

      if (!variantId || !sellingPlanId) {
        throw new Error(`Configuración incompleta para: ${familia} / ${plan}`);
      }

      const properties = {
        'Familia': familiaData.label,
        'Plan': plan,
        'Envío incluido': planData.envio_incluido ? 'Sí' : 'No',
        'Nota molienda': 'Si prefieres molido, indícalo en notas del pedido'
      };

      const payload = {
        items: [
          {
            id: variantId,
            quantity: quantity,
            selling_plan: sellingPlanId,
            properties: properties
          }
        ]
      };

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || 'Error al añadir al carrito');
      }

      // Éxito
      window.location.href = '/checkout';

    } catch (error) {
      console.error('Error en addToCart:', error);
      this.dom.ctaButton.disabled = false;
      this.dom.ctaButton.textContent = 'Error. Reintentar';
    }
  }
}

// Inicializar un constructor por cada sección en la página
document.querySelectorAll('.sub-builder-container').forEach(container => {
  new SubscriptionBuilder(container);
});